import { useLocation, useParams } from 'react-router-dom';

import { ReadonlyProvider } from 'core/readonly';
import InputsForm from 'features/inputs/InputsForm';
import useProjectOutputsQuery from 'shared/api/projects/useProjectOutputsQuery';
import useProjectQuery from 'shared/api/projects/useProjectQuery';
import MarkedAsFinalNotification from 'shared/projects/MarkedAsFinalNotification';
import useCanEditProject from 'shared/projects/useCanEditProject';

const InputsPage = () => {
  const { projectId } = useParams();
  const { state } = useLocation();

  const { data: project, isLoading } = useProjectQuery(projectId, {
    refetchOnMount: state?.refetchProject ?? true
  });

  const canEditProject = useCanEditProject(project?.details);

  const {
    data: outputs,
    isLoading: isOutputsLoading,
    isRefetching: isRefetchingOutputs
  } = useProjectOutputsQuery(projectId);

  return (
    <ReadonlyProvider value={!canEditProject}>
      {project?.details.isFinal && <MarkedAsFinalNotification projectId={projectId} />}
      <InputsForm
        project={project}
        isLoadingProject={isLoading || !project}
        isEditView
        isLoadingOverview={isOutputsLoading || isRefetchingOutputs}
        overview={outputs?.overview}
      />
    </ReadonlyProvider>
  );
};

export default InputsPage;
